module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/drums-and-percussion-ce20c77c169a936124b4445df1763f9b.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/drums-and-percussion.png
// module id = 7EWX
// module chunks = 12 16 18